import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function EditAbsencePage({ absence, onSave, onClose }) {
  const [editedAbsence, setEditedAbsence] = useState({
    ...absence,
    date: new Date(absence.date)
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedAbsence(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (date) => {
    setEditedAbsence(prev => ({
      ...prev,
      date: date
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(editedAbsence);
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Edit Absence</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block mb-2">Name:</label>
          <input
            type="text"
            name="name"
            value={editedAbsence.name}
            onChange={handleInputChange}
            className="w-full p-2 border rounded"
          />
        </div>
        <div className="mb-4">
          <label className="block mb-2">Date:</label>
          <DatePicker
            selected={editedAbsence.date}
            onChange={handleDateChange}
            className="w-full p-2 border rounded"
          />
        </div>
        <div className="mb-4">
          <label className="block mb-2">Reason:</label>
          <select
            name="reason"
            value={editedAbsence.reason}
            onChange={handleInputChange}
            className="w-full p-2 border rounded"
          >
            <option value="Excused">Excused</option>
            <option value="Unexcused">Unexcused</option>
            <option value="Vacation">Vacation</option>
            <option value="COVID">COVID</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block mb-2">
            <input
              type="checkbox"
              name="isExcused"
              checked={editedAbsence.isExcused}
              onChange={(e) => setEditedAbsence(prev => ({ ...prev, isExcused: e.target.checked }))}
              className="mr-2"
            />
            Is Excused
          </label>
        </div>
        <div className="flex justify-end">
          <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 mr-2">Save</button>
          <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400">Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default EditAbsencePage;
